module.exports = __webpack_public_path__ + "media/packs/images/flags/HN-0cc40b3ab391f0557198d62ed22c8e2f.png";